const PageTitle = ({ title }) => {
  return (
    <div id="hms-page-title">
      <h1 className="uk-heading-small">{title}</h1>
    </div>
  );
};

export default PageTitle;
